import React from "react";
import styled from "styled-components";

const CardFlip = () => {
    return (
        <StyledWrapper>
            <div className="uno-card">
                <div className="card-inner">
                    <div className="front">
                        <img src="/taisi/taisi-1.png" alt="TAISI Featured Page 1" className="taisi-image" />
                    </div>
                    <div className="back">
                        <img src="/taisi/taisi-2.png" alt="TAISI Featured Page 2" className="taisi-image" />
                    </div>
                </div>
            </div>
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 0;

    .uno-card {
        background-color: transparent;
        width: 600px;
        height: 900px;
        perspective: 1000px;
        transform-origin: center;
        border-radius: 15px;
    }

    .card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 1.1s;
        transform-style: preserve-3d;
        border-radius: 15px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }

    .uno-card:hover .card-inner {
        transform: rotateY(180deg) rotate(25deg);
    }

    .front,
    .back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        border-radius: 15px;
        overflow: hidden;
    }

    .front {
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .back {
        background-color: #fff;
        transform: rotateY(180deg);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .taisi-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 15px;
    }
`;

export default CardFlip;
